import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import { Link, useNavigate } from "react-router-dom";
import { ModalProps } from "react-bootstrap";

import "./StartAuthModal.scss";
import HyperTextIcon from "../../../images/group_hyper_word_icon.svg";
import Gift from "../../../images/gift.svg";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import { AuthFlow, LINKS, ROUTES } from "../../../utils/constants";
import ImageShimmer from "../../../images/shimmer.svg";
import LatestWinsSlider from "../LatestWinsSlider/LatestWinsSlider";
import ImageCloseIcon from "../../../images/close-icon.svg";
import ImageGamePadStars from "../../../images/game-pad-stars.png";
import { setStoredAuthFlow } from "../../../utils/storage";

function StartAuthModal({ show, onHide }: ModalProps) {
  const navigate = useNavigate();
  if (!show) return null;

  const handleSignup = () => {
    setStoredAuthFlow(AuthFlow.SIGNUP);
    navigate(`${ROUTES.ROOT.ONBOARDING}/${ROUTES.ONBOARDING.SELECT_REWARD}`);
  };

  const handleLogin = () => {
    setStoredAuthFlow(AuthFlow.LOGIN);
    navigate(`${ROUTES.ROOT.ONBOARDING}/${ROUTES.ONBOARDING.WELCOME_BACK}`);
  };

  return (
    <div className="auth-start-modal" role="dialog">
      <Container className="MobileOnly position-relative auth-start-container">
        <Col className="position-relative">
          <Link to="/">
            <Image className="signUpToHyperTextImage" src={HyperTextIcon} />
          </Link>
          <button className="close-btn position-absolute" onClick={onHide}>
            <Image src={ImageCloseIcon} height={30} width={30} />
          </button>
        </Col>
        <LatestWinsSlider />
        <Col className="imageGamepadContainer">
          <Image src={ImageGamePadStars} alt="game controller" />
        </Col>
        <h6 className="play-favourite-text">
          Play your favorite games, challenge friends, and win real money.
        </h6>
        <Container className="d-flex justify-content-center signUpButtonContainer mt-0">
          <div className="mb-2 position-relative">
            <div className="text-white completeSignUpWelcomeContainer animated-background">
              <Image src={ImageShimmer} alt="shimmer" className="shimmer" />
              <span className="completeSignUpWelcomeText">
                <Image className="me-1" src={Gift} height={12} width={12} />{" "}
                +100% Bonus
              </span>
            </div>
            <PrimaryActionButton
              textColor={"#FFFFFF"}
              text="Sign up for Free"
              textClassName="authButtonText"
              style={{ marginBottom: 12 }}
              onClick={handleSignup}
            />
          </div>
          <PrimaryActionButton
            textColor="white"
            text="Login"
            style={{ background: "#191040" }}
            textClassName="authButtonText"
            onClick={handleLogin}
          />
        </Container>
        <Container className="footerContainer MobileOnly">
          <span className="text-white footerText">
            By continuing, you agree that you are 18+ years old and you accept
            our
            <a
              href={LINKS.WEBPAGE.TERMS_AND_CONDITIONS}
              className="px-1"
              target="_blank"
              rel="noreferrer"
            >
              Terms & Conditions
            </a>
            and
            <a
              href={LINKS.WEBPAGE.PRIVACY_POLICY}
              className="px-1"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </span>
        </Container>
      </Container>
    </div>
  );
}

export default StartAuthModal;
